import { useTranslation } from 'react-i18next';

import { BpType } from '../../../../../../../enums';
import {
  IPatientsBpStatusFilter,
  usePatientsBpStatusFilters,
  useUpdatePatientsBpStatusFilter,
} from '../../../../../../../features/patients';
import { Filter, IFilterProps } from '../../../../../filter';

export const BpStatusFilter = () => {
  const { t } = useTranslation();
  const updateBpStatusFilter = useUpdatePatientsBpStatusFilter();
  const filters = usePatientsBpStatusFilters();

  const buttonProps: IFilterProps['button'] = {
    text: t('patients.filter.bpType'),
    filters,
    getText: (keys: string[]) => {
      if (keys.length > 1) {
        return t('patients.filter.active', { length: keys.length });
      }

      const key = keys[0];
      const text = t(`common.bpType.${key}`);
      if (key === BpType.STAGE_3) {
        return [text, t('common.bpType.HYPERTENSIVE_CRISIS')].join(' / ');
      } else {
        return text;
      }
    },
  };

  const popoverProps: IFilterProps['popover'] = {
    clearText: t('patients.filter.clear'),
    filters,
    getFilterText: (key) => t(`common.bpType.${key}`),
    onChange: (filters) => updateBpStatusFilter(filters as IPatientsBpStatusFilter),
    onClear: updateBpStatusFilter,
  };

  return <Filter button={buttonProps} popover={popoverProps} />;
};
